import React from 'react'
import { Price } from 'lib/shared/components'
import { Spinner } from 'lib/ui/components'
import { useFreeShippingData } from 'hooks/subscriptions'
import { useStoreView } from 'hooks/useStoreView'
import { Item } from '../Styled'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { getPackQty } from 'scenes/Product/components/OptionsSection'

interface Props {
  price: Record<string, any>
  frequency: number
  productId: number
  packageQty?: string
  setFrequency: (x: number) => void
  setPacksToAdd: (packs: number) => void
  classNameSelected?: string
  qtyPerDay: number
  packsToAdd?: number
}

export const ItemRenderer: React.FC<Props> = ({
  price,
  productId,
  frequency: itemFrequency,
  packageQty,
  setFrequency,
  setPacksToAdd,
  classNameSelected,
  qtyPerDay,
  packsToAdd
}) => {
  const piecesQty = packageQty ? parseInt(packageQty) : 0
  const packs = packsToAdd ?? (getPackQty?.(piecesQty, qtyPerDay, itemFrequency)) ?? 0
  const { loadingSubscription, itemDiscount } = useFreeShippingData(productId, (itemFrequency * 7), packs)
  const totalPieces = packs * piecesQty
  const { isLivBrite } = useStoreView()

  const handleSelection = () => {
    setFrequency(itemFrequency)
    setPacksToAdd(packs)
  }

  const priceValue = price.regularPrice?.amount.value ?? price.maximum_price?.final_price.value

  const finalPrice = itemDiscount ? (priceValue * packs) - itemDiscount : priceValue * packs

  return (
    <Item
      onClick={handleSelection}
      className={classNameSelected}
      isLivBrite={isLivBrite}
    >
      {loadingSubscription ? (
        <Spinner />
      ) : (
        <>
          <div>
            <p className='item__shipment'>Ship every {itemFrequency} weeks.</p>
            <div className='item__price'>
              <Price
                currency={DEFAULT_CURRENCY_CODE}
                value={finalPrice}
              />
            </div>
            <strong className='item__price-label'>per shipment</strong>
          </div>
          <div className='item__tag'>
            {packs} packs, {totalPieces} total pieces.
          </div>
        </>
      )}

    </Item>
  )
}
